<template>
    <div class="bg-theme-light mb-28 ">
      <div class="container px-6 py-16 mx-auto">
          <div class="items-center lg:flex">
              <div class="w-full lg:w-1/2">
                  <div class="lg:max-w-lg">
                    <h1  class="text-2xl text-gray-600 dark:text-white leading-9">{{banner.pretitle}} <br> 
                        <span class="text-theme-blue text-5xl font-bold"> {{banner.title}} </span> </h1>
                        <p class="mt-4 text-gray-600 dark:text-gray-400">{{banner.subtitle}} </p>
                        <!-- <p>{{title(banner)}}</p> -->
                      <div class="flex flex-col mt-8 space-y-3 lg:space-y-0 lg:flex-row">
                          <input v-model="this.filter" id="filter" type="text" 
                                 class="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring" 
                                 placeholder="Título, Autor..." 
                                 @keyup.enter="this.getBooks" >
                          
                            <router-link :to="{name:'Catalogo', params: {filterHome:this.filter}}" >
                                <button ref="mybtn" class="w-full h-10 flex items-center px-4 py-2 text-sm font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg lg:w-auto lg:mx-4 hover:bg-indigo-400 focus:outline-none focus:bg-indigo-400 ">
                                    <span class="font-semibold">Buscar</span>    
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                </button>
                            </router-link>
                      </div>
                  </div>
              </div>
      
              <div v-show="banner.title" class="flex items-center justify-center w-full mt-6 lg:mt-0 lg:w-1/2">
                  <img class="w-full h-full max-w-md" :src="img_banner" alt="#">
              </div>
          </div>
      </div>
    
    </div> 

</template>


<style>


</style>


<script>

    export default {
        props: {
            'banner':Object,
        },
        data(){
            const img_banner = require('@/assets/images/home/banner1.svg')
            return {
                img_banner,
                filter: ""
            }
        },
        methods: {
            getBooks() {
                var elem = this.$refs.mybtn
                elem.click()
            }
        }
    }

</script>
    